export default __webpack_public_path__ + "static/media/ups-and-downs.19442fc9.svg";